import React, { Component } from "react";
import Select from "react-select";
import { SkyLightStateless } from 'react-skylight';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import _ from 'lodash';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";
import axios from 'axios';
import {
  ROOT_URL, isSKH, isAGD
} from '../../../../actions/root_url';
import { InputField } from '../../inputField';

const fetchMissingSKUs = (id, success) => {
  let url;
  if (isSKH || isAGD) {
    url = `${ROOT_URL}v1/sale/list_missing_skus/${id}`
  } else {
    url = `${ROOT_URL}v2/sales/missing_skus/${id}`
  }

  axios({
    method: 'GET',
    url,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
  }).then(res => {
    console.log("WTF 1", res.data);
    success(res.data);
  }).catch(err => {
    alert(err.data);
  })
}
const modalStyle = {
  width: '500px',
  height: '500px',
  marginLeft: '-10%',
}

const propTypes = {
}

const defaultProps = {
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonToolbar: {
    display: 'flex',
    justifyContent: 'space-evenly',
    width: '100%',
    marginTop: '40px',
  }
}

class MissingSKUs extends Component {
  state = {
    missingSKUs: [],
  }
  componentDidMount() {
    const {
      salesOrders,
    } = this.props
    const success = (missingSKUs) => {
      console.log("WTF 2", missingSKUs);
      this.setState({ missingSKUs });
    }
    fetchMissingSKUs(salesOrders.selectedRows[0].SalesOrder_id, success);
  }

  // handleResyncClick = () => {
  //   const success = () => {
  //     this.props.setModalVisibility();
  //   }
  //   this.props.resyncTeapplix(this.state.PONum, success);
  // }

  renderSKUs = () => {
    if (isSKH) {
      return (
        <ul style={{ fontSize: '20px' }}>
          {_.map(this.state.missingSKUs, (sku) => {
            return <li>{sku.sku} - {sku.CPONum}</li>
          })}
        </ul>
      )
    }
    if (isAGD) {
      return (
        <ul style={{ fontSize: '20px' }}>
          {_.map(this.state.missingSKUs, (sku) => {
            return <li>{sku.sku}</li>
          })}
        </ul>
      )
    }
    return (
      <ul style={{ fontSize: '20px' }}>
        {_.map(this.state.missingSKUs, (sku) => {
          return <li>{sku}</li>
        })}
      </ul>
    )
  }

  render() {
    return (
      <form style={styles.container}>
        {this.state.missingSKUs.length ? this.renderSKUs() : <h4>No Missing SKUs Found</h4>}
        {/* <div style={styles.buttonToolbar}>
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            onClick={() => {
              // this.props.applyAndSave();
              this.props.setModalVisibility();
            }}
          >
            <Translate value="close" />
          </Button>
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            onClick={() => {
              this.handleResyncClick()
            }}
          >
            <Translate value="resync" />
          </Button>
        </div> */}
      </form>
    )
  }
}

const MissingSKUsModal = ({ isVisible, setModalVisibility, salesOrders }) => (
  <SkyLightStateless
    title={'MISSING SKUS'}
    onCloseClicked={setModalVisibility}
    dialogStyles={modalStyle}
    isVisible={isVisible}
  >
    <MissingSKUs setModalVisibility={setModalVisibility} salesOrders={salesOrders} />
  </SkyLightStateless>
)

MissingSKUsModal.propTypes = propTypes
MissingSKUsModal.defaultProps = defaultProps

export default MissingSKUsModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/MissingSKUsModal.jsx